import { Reveal } from "./Reveal";
import { BuyButton } from "./BuyButton";

export const FinalCTA = () => (
  <section className="bg-navy py-28 text-cream lg:py-36" data-testid="final-cta-section">
    <div className="mx-auto max-w-5xl px-6 lg:px-10">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-terra">
          Building a Speak-Up Culture™ Toolkit
        </p>
        <h2 className="mt-6 font-display text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
          Ready to deliver world-class civility training —{" "}
          <span className="text-terra">on your terms?</span>
        </h2>
        <p className="mt-8 max-w-2xl leading-relaxed text-cream/70 md:text-lg">
          One-time purchase. Instant download. Unlimited reuse. Join the consultants and
          people leaders turning bystanders into upstanders — with the exact program
          Civility Partners delivers for $10,000.
        </p>
        <div className="mt-12 flex flex-wrap items-center gap-6">
          <BuyButton testId="final-buy-button" size="lg">Get the Toolkit — $249</BuyButton>
          <p className="text-sm text-cream/50">Download · Brand · Deliver · Repeat</p>
        </div>
      </Reveal>
    </div>
  </section>
);
